/**
 * @file React context owning the agent chat transcript: the render list
 * `displayMessages` (`WELCOME_MESSAGE` prepended) and `messageCount` for
 * consumers that only gate on how many messages exist. Split out of `AIContext`
 * so a message write re-renders only transcript readers — `MessagesList` (the
 * list) and `Agent` (the count) — instead of every action/flag consumer.
 * `AIProvider` nests this provider inside `AIContext.Provider` and memoizes the
 * two values apart, so this is the only identity that churns per message. The
 * transcript is append-or-clear only, so a count read is no cheaper than a list
 * read; `messageCount` exists so `Agent` never touches message content.
 */
import { createContext } from 'react';
import type { ChatMessage } from './AIContext';

interface AITranscriptContextType {
  displayMessages: ChatMessage[];
  messageCount: number;
}

export const AITranscriptContext = createContext<AITranscriptContextType>({
  displayMessages: [],
  messageCount: 0,
});
